import {
  CustomizerContext,
  ITheme,
  ThemeProvider as LocalThemeProvider,
} from '@fluentui/react';
import { merge } from 'lodash';
import { useContext, Suspense } from 'react';
import { useFilterData } from './filterContext';
import { filterCustomizations } from './filterCustomizations';
import { SearchFilterShimmer } from './SearchFilterShimmer';

/**
 * Layout for the search filter.
 */
export const SearchFilterFrame = ({ children, visible }) => {
  const { customizations } = useContext(CustomizerContext);
  const { filterSettings } = useFilterData();
  const theme: ITheme = customizations?.settings?.theme;
  const background = theme?.palette.neutralLighterAlt;

  // Merge from lodash is a shallow merge. We should test out if deep merge
  // would work at a later date.
  const mergeCustomizations = merge({}, customizations, filterCustomizations);

  return (
    <div
      style={{
        background,
        padding: visible ? '0.5em 0.25em' : 0,
        margin: visible ? '0.5em' : 0,
        boxShadow: theme?.effects?.elevation4,
        borderRadius: theme?.effects?.roundedCorner4,
        transition:
          'height,margin,background,background-color,opacity 1s ease-in-out',
        opacity: visible ? 1 : 0,
      }}
    >
      <Suspense
        fallback={<SearchFilterShimmer length={filterSettings?.length} />}
      >
        {/* <LocalThemeProvider theme={filterCustomizations}>{children}</LocalThemeProvider> */}
        <LocalThemeProvider theme={mergeCustomizations}>
          {children}
        </LocalThemeProvider>
      </Suspense>
    </div>
  );
};
